import initialState from 'src/store/state'

// Target State
const moduleState = initialState.urlquery

// Actions

// Action Creators

// Reducers
const reducers = (state = moduleState, action:any) => {
  switch (action.type) {
    default:
      return state
  }
}

export default reducers
